import {
  APPOINTMENT_STATUS_TO_ARCHIVE,
  ARCHIVED_CLIENT_APPOINTMENTS,
  CLIENT_APPOINTMENTS,
  HISTORY_CLIENT_APPOINTMENTS,
} from "../constants";

const isActiveStatus = (ca) => CLIENT_APPOINTMENTS.includes(ca.appointment_t?.status);
const isArchivedStatus = (ca) => ARCHIVED_CLIENT_APPOINTMENTS.includes(ca.appointment_t?.status);
const isHistoryStatus = (ca) => HISTORY_CLIENT_APPOINTMENTS.includes(ca.appointment_t?.status);

/**
 * Split workflows into the three dashboard tabs.
 * When `moveArchivedActiveRows` is on, active-status rows with `archived: true`
 * leave WORKFLOW and appear on ARCHIVED WORKFLOW. History statuses stay on HISTORY.
 */
export const splitClientAppointmentsByTab = (clientAppointments, { moveArchivedActiveRows } = {}) => ({
  clientAppointments: clientAppointments.filter(
    (ca) => isActiveStatus(ca) && !(moveArchivedActiveRows && ca.archived === true)
  ),
  archivedClientAppointments: clientAppointments.filter(
    (ca) => isArchivedStatus(ca) || (moveArchivedActiveRows && ca.archived === true && isActiveStatus(ca))
  ),
  historyClientAppointments: clientAppointments.filter((ca) => isHistoryStatus(ca)),
});

/**
 * Auto-unarchive only when leaving a terminal status for an active one.
 * Manually archived rows already have an active status — editing Booked → To Book
 * must not clear `archived`. Use the Unarchive button for that.
 */
export const shouldUnarchiveOnStatusChange = ({ previousStatus, nextStatus, preserveManualArchive = false }) => {
  if (previousStatus === nextStatus) {
    return false;
  }
  if (APPOINTMENT_STATUS_TO_ARCHIVE.includes(nextStatus)) {
    return false;
  }
  if (preserveManualArchive && !APPOINTMENT_STATUS_TO_ARCHIVE.includes(previousStatus)) {
    return false;
  }
  return true;
};
